import { isGeneratedCodingPracticeTest1Enabled } from 'bundles/assignment-submission/FeatureFlags';

type ItemStatusProps = {
  courseId?: string;
  itemId?: string;
  itemTypeName?: string;
};

/**
 * This function is used to determine if the failed status should be skipped for an item.
 * @param computedItem - The computed item to check.
 * @returns true if the failed status should be skipped, false otherwise.
 */
export const skipFailedStatusForItem = ({ courseId, itemId, itemTypeName }: ItemStatusProps) => {
  // handling case of completed generated coding practice items
  // eventually we should update to only use dedicated item type name for coding practice items
  return (
    courseId &&
    itemId &&
    itemTypeName === 'ungradedAssignment' &&
    isGeneratedCodingPracticeTest1Enabled(courseId, itemId)
  );
};
